import PropTypes from 'prop-types';
import ChecklistItem from './ChecklistItem';
import {itemShape} from '../shapes';

export default function AllItemsView({groupedData, onToggleItem, onDeleteItem, onUpdateItem, onStarItem, onSetDueDateItem}) {
    if (groupedData.length === 0) {
        return (
            <div className="empty-state">
                <p className="empty-state-text">
                    No items anywhere. Either you're done or you never started.
                </p>
            </div>
        );
    }

    return (
        <div className="all-items-view">
            {groupedData.map((group) => (
                <div key={group.groupName} className="all-items-group">
                    <div className="all-items-group-header">{group.groupName}</div>
                    {group.checklists.map((checklist) => (
                        <div key={checklist.checklistId} className="all-items-checklist-section">
                            <div className="all-items-checklist-header">{checklist.checklistTitle}</div>
                            {checklist.items.map((item) => (
                                <div key={`${checklist.checklistId}-${item.id}`} className="timeline-item-wrapper">
                                    <ChecklistItem
                                        checklistId={checklist.checklistId}
                                        item={item}
                                        onToggle={onToggleItem}
                                        onDelete={onDeleteItem}
                                        onUpdate={onUpdateItem}
                                        onStar={onStarItem}
                                        onSetDueDate={onSetDueDateItem}
                                    />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

const allItemShape = PropTypes.shape({
    ...itemShape.innerType,
});

AllItemsView.propTypes = {
    groupedData: PropTypes.arrayOf(PropTypes.shape({
        groupName: PropTypes.string.isRequired,
        checklists: PropTypes.arrayOf(PropTypes.shape({
            checklistId: PropTypes.string.isRequired,
            checklistTitle: PropTypes.string.isRequired,
            items: PropTypes.arrayOf(allItemShape).isRequired,
        })).isRequired,
    })).isRequired,
    onToggleItem: PropTypes.func.isRequired,
    onDeleteItem: PropTypes.func.isRequired,
    onUpdateItem: PropTypes.func.isRequired,
    onStarItem: PropTypes.func.isRequired,
    onSetDueDateItem: PropTypes.func.isRequired,
};
